import Swiper, { Navigation } from "swiper";

export default class DevelopmentSlider {
    constructor() {
        this.slider = '.js-development-slider';
        
        this.init();
    }

    init() {

        const swiper = new Swiper(this.slider, {
            modules: [Navigation],
            loop:false,
            spaceBetween: 8,
            slidesPerView: 1.15,
            allowTouchMove: true,
            threshold: 20,
            navigation: {
                nextEl: ".js-development-slider-next",
                prevEl: ".js-development-slider-prev",
            },
            breakpoints: {
                1024: {
                    slidesPerView: 1,
                }
            },
            on: {
                slideChangeTransitionEnd: function(){
                    document.querySelector('.js-development-slider-index').textContent = this.activeIndex + 1;
                }
            }
        });

    }
}

new DevelopmentSlider;